export const encryptionKeys = {
  IV: '9g5y5fdlctdegrtv',
  key: '8pa7aohegahg5j2'
};

export const values = {
  CHAUFFER_BOOKED: 1,
  CHAUFFER_ON_THE_WAY: 2,
  CHAUFFER_NEAR_BY_LOCATION: 3,
  CHAUFFER_ARRIVE_NOW: 4,
  CHAUFFER_PICKUP_COMPLETED: 5,
  CHAUFFER_PICKUP_INCOMPLETE: 6,
  CHAUFFER_RIDE_STARTED: 7,
  CHAUFFER_RIDE_COMPLETED: 8,
  CHAUFFER_REACHED_GARAGE: 21,
  RENTAL_BOOKED: 9,
  RENTAL_STAGE_ONE_ON_THE_WAY: 10,
  RENTAL_STAGE_ONE_NEAR_BY_LOCATION: 11,
  RENTAL_STAGE_ONE_DROP_OFF_COMPLETED: 12,
  RENTAL_STAGE_TWO_ON_THE_WAY: 13,
  RENTAL_STAGE_TWO_NEAR_BY_LOCATION: 14,
  RENTAL_STAGE_TWO_PICKUP_COMPLETED: 15,
  RENTAL_STAGE_TWO_PICKUP_HEADING_TO_GARAGE: 16,
  RENTAL_STAGE_TWO_REACHED_GARAGE: 17,
  CANCELLED: 18,
  AUTO_CANCEL: 19,
  AUTO_KYC_CANCEL: 20,
  RENTAL_REACHED_GARAGE: 22,
  RENTAL_VEHICLE_PICKUP_COMPLETED: 23,
  RENTAL_VEHICLE_DROP_OFF: 24,
  RENTAL_REACHED_DESTINATION: 25,
  RENTAL_TWO_REACHED_DESTINATION: 26,
  RENTAL_TWO_DROP_OFF_COMPLETED: 27,
  CHAUFFER_HEADING_TO_PICKUP_LOCATION: 28,
  CHAUFFER_REACHED_PICKUP_LOCATION: 29,
  CHAUFFER_HEADING_TP_WAREHOUSE: 30,
  CHAUFFER_VEHICLE_DROP_OFF_COMPLETED: 31,
  RENTAL_BOOKED_DRIVER_ASSIGNED_PENDING: 32
};

export const BOOKING_TYPE = {
  SELF_DRIVING: 1,
  CHAUFFER_RENTAL: 2
};

export const PANEL_SERVICE_TYPE = {
  SELF_CHAUFFEUR: 1,
  RIDE_HAILING: 2
};

export const stageOneStatus = [9, 10, 11, 22, 23, 24, 25];
export const stageTwoStatus = [11, 12, 13, 14, 26, 15, 16, 17, 27];
export const stageTwoDetailsStatus = [12, 13, 14, 26, 15, 16, 17, 27];
export const chaufferBookingStatusNum = [ 1, 2, 3, 4, 5, 28, 29, 7, 8, 30, 21, 31];
export const liveTrackingStatus = [ 3, 4, 5, 11, 14, 23, 24, 25, 26, 28, 13, 14, 29];
export const nonTrackingDriverInfoStatus = [1, 2, 9, 32, 10, 11, 22, 23];


// Ride-Hailing (PANEL_SERVICE_TYPE.RIDE_HAILING) status handling.

export const RhRideStatus = {
  RIDE_BOOKED: 32,
  DRIVER_ASSIGNED: 33,
  START_RIDE: 34,
  NEAR_BY_PICKUP: 35,
  ARRIVED_AT_PICKUP: 36,
  WAITING: 37,
  RIDE_STARTED: 38,
  NEAR_BY_ARRIVING: 39,
  RIDE_COMPLETED: 40,
  CANCELLED_BY_CUSTOMER: 41,
  CANCELLED_BY_DRIVER: 42,
  DRIVER_NOT_FOUND: 43,
  NO_SHOW: 44,
  SCHEDULED: 45,
  ARRIVED_AT_DROPOFF: 46,
  DRIVER_NOT_FOUND_AUTO_CANCEL: 47,
  CANCELLED_BY_ADMIN: 48
} as const;

export const rhRideStatusLabel: Record<number, string> = {
  [RhRideStatus.RIDE_BOOKED]: "Searching",
  [RhRideStatus.DRIVER_ASSIGNED]: "ChaufferAssigned",
  [RhRideStatus.START_RIDE]: "ChaufferOnTheWay",
  [RhRideStatus.NEAR_BY_PICKUP]: "ChaufferArrivingAtPickup",
  [RhRideStatus.ARRIVED_AT_PICKUP]: "ArrivedAtPickup",
  [RhRideStatus.WAITING]: "Waiting",
  [RhRideStatus.RIDE_STARTED]: "RideStarted",
  [RhRideStatus.NEAR_BY_ARRIVING]: "ArrivingAtDropOff",
  [RhRideStatus.RIDE_COMPLETED]: "RideCompleted",
  [RhRideStatus.CANCELLED_BY_CUSTOMER]: "BookingCancelled",
  [RhRideStatus.CANCELLED_BY_DRIVER]: "BookingCancelled",
  [RhRideStatus.DRIVER_NOT_FOUND]: "DriverNotAssigned",
  [RhRideStatus.NO_SHOW]: "CustomerNoShow",
  [RhRideStatus.SCHEDULED]: 'Scheduled',
  [RhRideStatus.ARRIVED_AT_DROPOFF]: 'ArrivedAtDropOff'
};

export const rhNonTrackingDriverInfoStatus: number[] = [RhRideStatus.RIDE_BOOKED];

export const rhLiveTrackingStatus: number[] = [
  RhRideStatus.DRIVER_ASSIGNED,
  RhRideStatus.START_RIDE,
  RhRideStatus.NEAR_BY_PICKUP,
  RhRideStatus.ARRIVED_AT_PICKUP,
  RhRideStatus.WAITING,
  RhRideStatus.RIDE_STARTED,
  RhRideStatus.NEAR_BY_ARRIVING,
  RhRideStatus.ARRIVED_AT_DROPOFF
];

export const rhEndedStatus: number[] = [
  RhRideStatus.RIDE_COMPLETED,
  RhRideStatus.CANCELLED_BY_CUSTOMER,
  RhRideStatus.CANCELLED_BY_DRIVER,
  RhRideStatus.DRIVER_NOT_FOUND,
  RhRideStatus.NO_SHOW
];